module.exports = __webpack_public_path__ + "static/media/Marimba.rubber.ff.G6.stereo.2865f7d2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/stores/audio/Marimba.rubber.ff.G6.stereo.mp3
// module id = 624
// module chunks = 0